import { render } from "./RichiestaDetail.vue?vue&type=template&id=2062baae&scoped=true"
import script from "./RichiestaDetail.vue?vue&type=script&lang=js"
export * from "./RichiestaDetail.vue?vue&type=script&lang=js"

import "./RichiestaDetail.vue?vue&type=style&index=0&id=2062baae&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ecocomfort/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2062baae"]])

export default __exports__